import styled from 'styled-components';

export const StepCounter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 18px;
    font-weight: 500;

    width: 50px;
    height: 50px;
    border-radius: 50%;
    color: #fff;
    background-color: #d7d7d7;
`;

export const StepLine = styled.div`
  width: 100%;
  flex: 1;
  height: 1px;
  background-color: #d7d7d7;
  margin: 0 16px;
  @media(min-width: 850px) {
    margin-left: 0;
  }
`;

export const StepLabel = styled.h3`
  color:  #000;
  font-weight: 400;
  font-size: 16px;
  margin: 0 12px;
  display: none;

  @media(min-width: 850px) {
    display: block;
  }
`;

export const StepStyled = styled.li.attrs((props) => ({ className: props.className }))`
    display: flex;
    align-items: center;
    flex: 2 1 auto;
    font-size: 12px;
    --circle-size: clamp(2.5rem, 4vw, 3rem);
    font-weight: 500;

    &:last-child {
        flex: 1;
        margin-right: 0;
    }

    &:last-child ${StepLabel} {
        margin-right: 0;
    }

        // &.visited ${StepCounter} {
    //     color: #fff;
    //     background-color: #aed540;
    //
    //     //border: 1px solid #aed540;
    // }

    &.active ${StepCounter} {
        background-image: linear-gradient(274deg, rgba(0, 120, 212, 0.3) 12.57%, rgba(141, 200, 232, 0.3) 93.07%);
        color: #fff;
        outline: 1px solid rgba(56, 125, 255, 0.5); /* Offset border */
        outline-offset: 2px;
    }

    &.danger ${StepCounter} {
        background-color: #fee7ef;
        border: 1px solid #c20e4d;
        color: #c20e4d;
    }

    &.active ${StepLabel} {
        color: #000;
    }

    &.visited ${StepLabel} {
        color: #000;
    }
`;

export const StepperContainer = styled.section`
  width: 100%;
  margin: 0 auto;
  padding:25px 0;
`;

export const StepperWrapper = styled.ol`
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0;
`;

export const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
